import { render } from "./SaleSchemajson.vue?vue&type=template&id=7ee37944"
import script from "./SaleSchemajson.vue?vue&type=script&lang=js"
export * from "./SaleSchemajson.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__